import { render, staticRenderFns } from "./assetdetails.vue?vue&type=template&id=89ca0c58&scoped=true"
import script from "./assetdetails.vue?vue&type=script&lang=js"
export * from "./assetdetails.vue?vue&type=script&lang=js"
import style0 from "./assetdetails.vue?vue&type=style&index=0&id=89ca0c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ca0c58",
  null
  
)

export default component.exports